<template lang="html">
    <div class="single_content">
        <single-card>
            <template slot="content">
                <v-layout>
                    <v-flex xs12>
                        <div class="subtitle"> Synchro </div>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-btn color="primary" outline round flat @click="resync">Tout resynchroniser</v-btn>
                </v-layout>
            </template>
        </single-card>
        <v-dialog
          v-model="modal"
          max-width="500px"
          persistent
        >
            <v-card>
                <!-- open a modal with a loader the time of the sync -->
                <div class="loader">
                    <img src="../../../assets/img/grid_loader.svg" />
                    <p>Resynchro en cours</p>
                </div>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
import SingleCard   	from '../../../components/single/SingleCard.vue'
export default {
    components: {SingleCard},
    data(){
        return {
            modal:false,
        }
    },
    methods: {
        resync() {
            this.modal = true
            this.axios.post(`/api/dailyResync`)
            .then(response => {
                this.modal = false
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.loader
    display flex
    flex-direction column
    align-items center
    width 100%
    padding 3rem 0

    img
        margin 0 0 3rem
</style>



// WEBPACK FOOTER //
// src/views/admin/sync/single.vue